<template>
  <span v-if="field"
        :class="{ negative: object[field.id] < 0, 'nowrap': field.format_hours }">
    <template v-if="field.form && field.form.type === 'select' && field.form.options && !props.field.table_show">
      {{ field.form.translate === false ? selectOption : $t(selectOption) }}
    </template>
    <span v-else-if="field.format_html" v-html="string"></span>
    <template v-else-if="isFormatNumber">{{ formatNumber(string, true) }}</template>
    <template v-else-if="field.format_currency">{{ formatCurrency(string) }}</template>
    <template v-else-if="field.format_currency_dot"><TDCurrencyDot :string="string"/></template>
    <template v-else-if="field.format_percent">{{ string ? formatNumber(string)+'%' : '-' }}</template>
    <template v-else-if="field.format_email"><a :href="`mailto:${object[field.id]}`">{{ string }}</a></template>
    <template v-else-if="field.format_phone"><a class="td-phone" :href="`tel:${object[field.id]}`">{{ formatPhone(string) }}</a></template>
    <template v-else-if="field.format_phonecall"><OutgoingCallElement :phone="object[field.id]"/></template>
    <template v-else-if="field.format_date">{{ formatDate(string) }}</template>
    <template v-else-if="field.format_date_short_year">{{ formatDate(string, 'DD.MM.YY') }}</template>
    <template v-else-if="field.format_datetime">{{ formatDate(string, 'DD.MM.YYYY, HH:mm') }}</template>
    <template v-else-if="field.format_filesize">{{ formatFileSize(string) }}</template>
    <template v-else-if="field.format_translate">{{ string && $te(string) ? $t(string) : string }}</template>
    <template v-else-if="field.format_json"><pre><code>{{ string && $te(string) ? $t(string) : string }}</code></pre></template>
    <template v-else-if="field.format_boolean">{{ string ? $t('yes') : $t('no') }}</template>
    <template v-else-if="isFormatHours">{{ formatHours(string) }}</template>
    <template v-else-if="field.format_image"><a :href="string" target="_blank"><img class="admin-table-img" :src="string" alt=""/></a></template>
    <template v-else>{{ string }}</template>
  </span>
</template>

<script setup>
import OutgoingCallElement from "@/components/parts/patients/OutgoingCallElement.vue"
import {
  formatPhone,
  formatNumber,
  formatCurrency,
  formatDate,
  formatFileSize,
  nestedAttribute,
  formatHours
} from "@/extensions/filters/filters"
import { computed } from "vue"
import TDCurrencyDot from "@/components/parts/general/TDCurrencyDot.vue"

const props = defineProps({
  field: {
    type: Object
  },
  object: {
    type: Object
  },
})

const string = computed(() => {
  if(props.field.table_show) {
    if(props.field.table_show instanceof Function) {
      return props.field.table_show(props.object)
    }
    let show = props.field.table_show
    if(!Array.isArray(props.field.table_show)) show = [show]
    let str = ''
    show.forEach((item, index) => {
      if(index > 0) str += ', '
      str += nestedAttribute(props.object, item)
    })
    return str
  }
  return props.object[props.field.id]
})

const selectOption = computed(() => {
  if(props.field.form && props.field.form.type === 'select' && props.field.form.options) {
    if(!props.object[props.field.id] && props.object[props.field.id] !== '0' && props.object[props.field.id] !== 0) return ''
    return props.field.form.options[props.object[props.field.id]]?.title || props.object[props.field.id]
  }
  return ''
})

const isFormatHours = computed(() => {
  if(props.object?.subtitle === 'количество пациентов' && (props.field.id === 'total' || !isNaN(new Date(props.field.id)))) return false
  return props.field.format_hours
})

const isFormatNumber = computed(() => {
  if(props.object?.subtitle === 'количество пациентов' && (props.field.id === 'total' || !isNaN(new Date(props.field.id)))) return true
  return props.field.format_number
})

</script>
